/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserLoginComponent } from './userLogin/userLogin.component';
import { UserLevelCheckDirective } from './userLevelCheck/userLevelCheck.directive';
import { UserAuthenticationResourceManager } from './resources/resource.service';
import { IUserAuthenticationService, IUSERAUTHENTICATIONSERVICE_TOKEN } from './interfaces/IUserAuthenticationService.interface';
import { IUserAuthStateService, IUSERAUTHSTATESERVICE_TOKEN } from './interfaces/IUserAuthStateService.interface';
import { UserAuthStateService } from './userAuthState/UserAuthState.service';
import { CommonUiModule } from '../../commonUi/src/commonUi.module';
import { TranslateModule } from '../../translate/src/translate.module';

@NgModule({
    imports:
    [
        CommonUiModule,
        FormsModule,
        TranslateModule
    ],
    exports:
    [
        UserLoginComponent,
        UserLevelCheckDirective
    ],
    declarations:
    [
        UserLoginComponent,
        UserLevelCheckDirective
    ],
    providers:
    [
        UserAuthenticationResourceManager, { provide: 'Window', useValue: window }
    ],
    bootstrap: []
})

export class UserAuthenticationModule {
    //Resource manager adds the translations to the translationservice
    constructor(private _resourceManager: UserAuthenticationResourceManager ) {}
}